<template>
  <div class="jy-businessAgreement">
    <div>
      <div class="title">剑琅联盟商户合作协议</div>特别声明：
      <br />
      <div
        class="pt"
      >在签署本协议前，您确认已经仔细阅读并完全同意《剑琅联盟用户服务协议》之全部内容。同时，作为商户，您承诺仔细阅读并全面遵守本协议之全部内容。如果您不同意本协议的任意内容，或者无法准确理解剑琅联盟对条款的解释，请不要同意本协议或使用本协议项下的服务，否则，表示您已接受了以下所述的条款和条件，同意受本协议约束。届时您不应以未阅读本协议的内容等理由，主张本协议无效，或要求撤销本协议。</div>
      <div
        class="pt"
      >考虑到互联网信息服务性质和内容的不断发展和演进，您同意剑琅联盟有权对本协议条款进行修改，并将修改后的协议以在线公布、通过您注册时提供的通讯工具发送或者其他任何合理方式通知您。您同意承担及时查阅最新协议的义务。在该等修改发生后，若您不同意该最新协议，您应放弃注册、停止使用或主动取消本公司提供的服务。您继续使用本公司提供的服务的行为将被视为对该最新协议的全部内容予以接受和同意。如剑琅联盟需要商户与剑琅联盟另行签署协议的，则商户还应遵守另行签署的协议，若本协议与商户另行签署协议不一致的，以双方另行签署的协议为准。</div>
      <br />
      <div>第一条 签约背景</div>
      <br />
      <div>为更好的为合作商户提供服务,同时为更好的规范商户注册、发布服务内容，以及更好的使用剑琅联盟提供的其他增值服务，特签署本协议。</div>
      <br />
      <div>第二条 签约主体</div>
      <br />
      <div>本协议由剑琅联盟与通过注册获得剑琅联盟授权使用的商户签署。商户在本协议中多数称呼为“您”或“商户”。</div>
      <br />
      <div>第三条 协议订立、生效及其适用范围</div>
      <br />
      <div>1.您通过应用程序页面点击确认本协议或以勾选等其他方式选择接受本协议，包括但不限于未确认本协议而使用了剑琅联盟其他增值服务功能，均表示您与剑琅联盟已就本协议达成一致并同意接受本协议的全部约定内容。</div>
      <div>2.本协议自您确认或使用本协议之时即生效。</div>
      <div>3.您了解并同意，根据您实施的不同行为，您将受到本协议不同条款的约束。</div>
      <br />
      <div>第四条 定义</div>
      <br />
      <div>1.商户：指使用剑琅联盟服务系统在线下为顾客提供服务的实体商户经营管理者，又称呼为“店铺”。</div>
      <div>2.商户信息：指由商户发布的商户基本信息，包括但不限于商户名称、地址、联系方式、负责人、员工等。</div>
      <div>3.顾客：指线下消费者，接受商户提供的服务并支付对价。</div>
      <div>4.推荐方：指推荐服务的商户或其授权使用的个人。</div>
      <div>5.百搭通：指剑琅联盟运营的微信小程序，用于商户推广、记录交易订单、服务费结算等功能。</div>
      <br />
      <div>第五条 合作内容及功能</div>
      <br />
      <div>
        1.商户通过注册及使用剑琅联盟进行服务管理、发布服务内容，剑琅联盟提供相关服务功能的管理与技术支持。具体功能包括：
        <br />（1）设立账户
        <br />（2）展示、发布服务内容
        <br />（3）设置优惠券或二维码
      </div>
      <br />
      <div>2.促销活动</div>
      <div>为拓展顾客，您应积极参与剑琅联盟不定期推出的促销活动，具体执行规则参见每次活动更新。</div>
      <br />
      <div>3.服务费</div>
      <div>百搭通收费规则：商户通过百搭通完成下单与支付的，则按照交易额的5%向商户收取推广服务费。商户须注意百搭通有权根据业务发展对收费率及收费方式进行调整。</div>
      <br />
      <div>第六条商户合作义务</div>
      <br />
      <div>您应遵守本协议的条款和法律法规的规定，通过使用剑琅联盟享有更高效、便捷的商户管理系统以及开拓市场的服务系统。因您的不合作行为给剑琅联盟造成的任何损失，应承担全部赔偿责任。</div>
      <br />
      <div>1.如您的账户45天内未进行以下活动，则剑琅联盟有权利终止您的账户。这将导致您的账户不能再登录剑琅联盟系统，相应服务亦同时终止：</div>
      <div>1)未进行任何申请发布优惠活动；</div>
      <div>2)未有任何验证优惠券记录；</div>
      <br />
      <div>2.您应允许顾客使用积分抵扣原价消费，不得擅自虚高价格、虚假优惠；如被查处，则剑琅联盟有权下架您的优惠券、店铺或终止您的账户。</div>
      <br />
      <div>3.您应依照中国人民共和国相关税法对经营所得履行相应纳税义务。您有提供发票资质的，须在收到返利后10个工作日内向剑琅联盟提供发票。您是自然人的，须在收款后税法规定的纳税申报期限内向税务机关申报缴纳个人所得税，或协商后由剑琅联盟代扣代缴。</div>
      <br />
      <div>4.经您同意并授权，可以使用剑琅联盟签约的第三方支付机构提供的结算服务，包括账户开立、绑卡、解绑卡、查询、充值、提现、结算对账、资金划转等功能并按照相关要求如实提供交易信息。</div>
      <br />
      <div>第七条 商户陈述与保证</div>
      <br />
      <div>1.商户承诺其是其认领商户信息对应的实体商户的真实经营管理者；</div>
      <br />
      <div>2.商户承诺其是其发布新的商户信息对应的实体商户的真实经营管理者；</div>
      <br />
      <div>3.商户承诺发起的交易基于真实的交易背景，不得利用剑琅联盟提供的服务进行虚假交易或恶意发布虚假信息，否则商户承诺独立承担因此导致的相应责任及后果，使剑琅联盟免责；</div>
      <br />
      <div>4.商户承诺其通过平台发布、编辑、更新的商户信息(包括但不限于文字、图片等)真实准确，并且不侵犯任何人的合法权益；</div>
      <br />
      <div>5.商户承诺在其接受增值服务、推荐服务时，严格遵守相关服务协议的相关约定；</div>
      <br />
      <div>6.商户同意在使用剑琅联盟商户服务的同时接受剑琅联盟向其登记的电子邮件、手机、通信地址发送商业信息。</div>
      <br />
      <div>7.若商户对剑琅联盟实施侵权行为或者商户违反与剑琅联盟的约定导致剑琅联盟受损，且该商户有任何存储于剑琅联盟的付款、应收款等资产或者利益，则该商户同意并授权剑琅联盟从该资产或者利益中优先扣除该商户之侵权或者违约行为应支付给剑琅联盟的赔偿金，以履行其赔偿义务。</div>
      <br />
      <div>8.商户知悉并同意：商户因其经营需要、履行本协议义务而向剑琅联盟提交的任何信息和数据，以及商户在经营过程中产生的交易数据、用户点击、店铺及商品评价数据，剑琅联盟有权在本协议终止后继续保留，同时，无论本协议终止前还是终止之后，剑琅联盟均有权合理使用，使用方式包括但不限于依据数据进行市场分析和调研，或就分析、调研结果以产品形式售卖或免费提供给第三方；商户进一步知悉并同意：该等数据，无论本协议终止前还是终止之后，剑琅联盟均无义务返还商户、也无义务删除原始数据及其备份、同时无义务就使用该数据的行为向商户支付任何费用。</div>
      <br />
      <div>第八条 剑琅联盟的权利及责任限制</div>
      <br />
      <div>1.剑琅联盟致力于不断提高商户服务的产品与技术质量以及系统的安全稳定；</div>
      <br />
      <div>2.剑琅联盟作为商户服务的技术服务提供商将按“现状”和按“可得到”的状态提供服务。剑琅联盟在此明确声明对商户服务不作任何明示或暗示的保证，包括但不限于对该服务的可适用性、没有错误或疏漏、持续性、准确性、可靠性、适用于某一特定用途之类的保证、声明或承诺。</div>
      <br />
      <div>3.在所适用的法律允许的范围内，剑琅联盟不做任何明示的或默示的声明，也不给予任何明示的或默示的保证或条件，包括但不限于：</div>
      <div>(1)关于适用性、特定用途适用性、准确性和无侵权行为的任何保证或条件；</div>
      <div>(2)在服务使用过程或行业惯例中产生的任何保证或条件；</div>
      <div>(3)在访问或使用商户服务时不受干扰、没有错误的任何保证或条件；</div>
      <div>(4)在任何书面或者口头的帮助、答疑过程中所作出的陈述、指导或者展示。</div>
      <br />
      <div>4.在法律允许的最大免责范围内，在任何情况下剑琅联盟均不对源于、基于或因本协议或使用商户服务而导致的数据丢失和/或任何损害赔偿负责，包括但不限于直接的、间接的、特殊的、附带性的或惩罚性的损害赔偿或其他任何形式的损害赔偿，即使剑琅联盟已被告知此等损害赔偿的可能性。</div>
      <br />
      <div>5.剑琅联盟对商户的任何通知，不论是口头还是书面的，均不表示剑琅联盟承担在本协议陈述以外的任何担保责任。</div>
      <br />
      <div>6.对下列情形，剑琅联盟在法律允许的最大免责范围内予以免责：</div>
      <div>(1)并非剑琅联盟的故意或过失而导致服务或者软件、信息无法使用。</div>
      <div>(2)并非剑琅联盟的故意或过失而导致推荐方未能获得返利。</div>
      <div>(3)由于商户或第三人的故意或过失导致其及/或任何第三方遭受损失。</div>
      <div>(4)因剑琅联盟合理控制范围以外的原因，包括但不限于不可抗力、政府行为和电力电信中断等，导致剑琅联盟未能履行或未能完全履行本合同的。</div>
      <div>在法律允许的最大免责范围内，剑琅联盟保留随时修改或中断服务而不需通知商户的权利，不需对商户或任何无直接关系的第三方负责。除非法律另有规定或者双方另有特别约定。</div>
      <br />
      <div>7.如商户违反本协议第七条约定的承诺及保证，剑琅联盟有权采取一切必要的措施包括但不限于：删除商户发布的内容、取消商户获得的荣誉，暂停或查封商户帐号，取消因违规所获利益，终止本服务协议，乃至通过诉讼形式追究商户法律责任等。</div>
      <br />
      <div>第九条 知识产权及其它权利</div>
      <br />
      <div>1.剑琅联盟所提供的各项服务的所有权和运作权归上海集勇信息科技有限公司(以下简称“本公司”)。除特别说明或者法律另有特别规定外，本公司是剑琅联盟及其中所刊登全部资料、信息的知识产权的唯一所有人。除法律法规或者本平台另有规定/约定外，用户通过平台发布的消息一经发布即向公众传播和共享。</div>
      <br />
      <div>2.本平台所刊登的全部资料包括但不限于程序设计、程序代码、页面图文、音频、视频等信息，以及依据本平台独有的分析模 型计算的商户星级、人均花费、环境、服务分数等数据信息。</div>
      <br />
      <div>3.任何商户接受本协议，即表明该商户主动将其在任何时间段在本站发表的任何形式的信息的著作财产权，包括并不限于：复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权等，以及应当由著作权人享有的其他可转让权利无偿独家转让给剑琅联盟运营商所有，同时表明该商户许可剑琅联盟有权利就任何主体侵权而单独提起诉讼，并获得全部赔偿。本协议已经构成《著作权法》或者相关法律法规所规定的书面协议，其效力及于商户在剑琅联盟发布的任何受著作权法保护的作品内容，无论该内容形成于本协议签订前还是本协议签订后。</div>
      <br />
      <div>4.剑琅联盟拥有此平台内容及资源的版权,受国家知识产权保护,享有对本平台各种协议、声明的修改权；未经剑琅联盟的明确书面许可，任何第三方不得为任何非私人或商业目的获取或使用本平台的任何部分或通过本平台可直接或间接获得的任何内容、服务或资料。任何第三方违反本协议的规定以任何方式，和/或以任何文字对本平台的任何部分进行发表、复制、转载、更改、引用、链接、下载或以其他方式进行使用，或向任何其他第三方提供获取本平台任何内容的渠道，则对本平台的使用权将立即终止，且任何第三方必须按照剑琅联盟的要求，归还或销毁使用本平台任何部分的内容所创建的资料的任何副本。</div>
      <br />
      <div>5.剑琅联盟未向任何第三方转让本平台或其中的任何内容所相关的任何权益或所有权，且一切未明确向任何第三方授予的权利均归剑琅联盟所有。未经本协议明确允许而擅自使用本平台任何内容、服务或资料的，构成对本协议的违约行为，且可能触犯著作权、商标、专利和/或其他方面的法律法规，剑琅联盟保留对任何违反本协议规定的第三方(包括单位或个人等)提起法律诉讼的权利。</div>
      <br />
      <div>第十条 适用法律与争议解决</div>
      <br />
      <div>1.因商户使用剑琅联盟站商户服务而引起或与之相关的一切争议均应依照中华人民共和国制定的法律法规(不包括冲突法)予以处理，并以上海市黄浦区人民法院为管辖法院。</div>
      <br />
      <div>2.如本协议的任何条款被视作无效或无法执行，则上述条款可被分离，其余部份则仍具有法律效力。</div>
      <br />
      <div>3.剑琅联盟于商户过失或违约时未行使本协议规定的权利的，不得视为其对商户的其他或以后同类之过失或违约行为弃权。</div>
      <br />

      <div>附件一《商户入驻规则》</div>
      <div>一、商户入驻类型要求</div><br>
      <div>1.企业/公司</div>
      <div>适合营业执照名称或类型包含有限责任公司、股份有限公司、合伙企业</div>
      <br />
      <div>2.个体工商户</div>
      <div>适合营业执照名称或类型包含个体工商户、个人独资企业的公司</div>
      <br />
      <div>3.小微商户</div>
      <div>适合正在办理企业或个人营业执照的商户</div>
<br>
      <div>二、商户入驻资料准备</div><br>
      <div>企业/公司资质列表</div>
      <div>1.营业执照（需确所提供商品或服务在营业执照经营范围内且无严重企业异常状况）</div><br>
      <div>2.法定代表人身份证正反面</div><br>
      <div>3.经营场所地址和联系方式，提供店内外实拍图片</div><br>
      <div>4.对公账户（银行账户相关信息）</div><br>

      <div>个体工商户资质列表</div>
      <div>1.营业执照（需确所提供商品或服务在营业执照经营范围内且无严重企业异常状况）</div><br>
      <div>2.法定代表人身份证正反面</div><br>
      <div>3.经营场所地址和联系方式，提供店内外实拍图片</div><br>
      <div>4.个人或对公账户（银行账户相关信息）</div>
<br>
      <div>小微商户资质列表</div>
      <div>1.个人身份证正反面</div><br>
      <div>2.经营场所地址和联系方式，提供店内外实拍图片</div><br>
      <div>3.个人银行账户（银行账户相关信息）</div><br>

      <div>三、注意事项</div><br>
      <div><b>实体门店</b>：商户必须有提供相关服务的经营场所。根据不同主体与行业与，需要符合该合法的经营资质与许可。</div><br>
      <div><b>提现路径</b>：企业/公司收入仅可提现至对公账户；个体工商户收入可提现至法人个人银行卡或对公账户；小微商户收入可提现至个人银行卡，个税自理。</div><br>
      <div><b>纳税义务</b>：您应依照中国人民共和国相关税法对经营所得履行相应纳税义务。您有提供发票资质的，须在收到返利后10个工作日内向剑琅联盟提供发票。您是自然人的，须在收款后税法规定的纳税申报期限内向税务机关申报缴纳个人所得税，或协商后由剑琅联盟代扣代缴。</div><br>
      <div><b>结算服务</b>：经您同意并授权，可以使用剑琅联盟签约的第三方支付机构提供的结算服务，包括账户开立、绑卡、解绑卡、查询、充值、提现、结算对账、资金划转等功能并按照相关要求如实提供交易信息。</div>
      <br />
      <div>四、申请流程</div>
      <br />
      <p>
        点击首页“立即开店”
        <br />↓
        <br />开始“网店认证
        <br />↓
        <br />填写商铺信息、上传资质材料
        <br />↓
        <br />提交开业申请
        <br />↓
        <br />资质审核
        <br />↓
        <br />3～5个工作日内通知审核结果
        <br />↓
        <br />审核通过，店铺正式运营
      </p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {}
};
</script>
<style scoped>
.jy-businessAgreement {
  padding: 17px;
  font-size: 13px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(66, 66, 66, 1);
  line-height: 18px;
}
.pt {
  text-indent: 2em;
}
.title {
  text-align: center;
  height: 30px;
  font-size: 22px;
  font-family: PingFangSC-Medium;
  font-weight: bold;
  color: rgba(66, 66, 66, 1);
  line-height: 30px;
  margin: 19px 0 11px 0;
}
</style>



// WEBPACK FOOTER //
// src/views/userAgreements/BusinessAgreement.vue